export const CREDIT_CARDS_LIST = [
  {
    title: "Кредитная карта на 365 дней",
    description: "Сделай лучший выбор: Халва или кредитная карта?",
    url: "https://halvacard.ru/order/credit-card/s-besprocentnym-periodom-god/",
  },
  {
    title: "Кредитная карта со снятием наличных",
    description: "Универсальная Халва или только кредитка?",
    url: "https://halvacard.ru/order/credit-card/kreditnie-karti-so-snyatiem-nalichnih-bez-protsentov/",
  },
  {
    title: "Кредитная карта на 100 дней",
    description: "Карта с лимитом на 100 дней или безлимитная Халва?",
    url: "https://halvacard.ru/order/credit-card/bez-procentov-100-dney/",
  },
  {
    title: "Виртуальная кредитная карта",
    description: "Халва с кешбэком и бонусами или другие карты?",
    url: "https://halvacard.ru/order/credit-card/virtualnaya/",
  },
  {
    title: "Кредитная карта без отказа",
    description: "Халва без ограничений или кредитка без отказа?",
    url: "https://halvacard.ru/order/credit-card/bez-otkaza/",
  },

  {
    title: "Кредитная карта с онлайн-заявкой",
    description: "Моментальная Халва или карты с онлайн-заявкой?",
    url: "https://halvacard.ru/order/credit-card/online-zayavka/",
  },
  {
    title: "Кредитная карта «МИР»",
    description: "Беспроцентная «Халва Мир» или кредитная карта «Мир»?",
    url: "https://halvacard.ru/order/credit-card/mir/",
  },
  {
    title: "Срочная кредитная карта",
    description: "Выбирайте: срочная кредитная карта или карта «Халва»?",
    url: "https://halvacard.ru/order/credit-card/srochnaya/",
  },
  {
    title: "Кредитная карта на 120 дней",
    description: "Беспроцентная Халва или стандартный лимит по карте?",
    url: "https://halvacard.ru/order/credit-card/s-besprocentnym-periodom-120-dnej/",
  },
  {
    title: "Кредитная карта с кэшбэком",
    description: "Пять преимуществ Халвы или только один кэшбэк?",
    url: "https://halvacard.ru/order/credit-card/kreditnie-karti-s-keshbekom/",
  },

  // TODO: НЕ УДАЛЯТЬ, ВРЕМЕННО НЕ ПОКАЗЫВАТЬ !!!
  // {
  //   title: "Кредитная карта без посещения банка",
  //   description: "Получить кредитную карту без посещения банка или карту «Халва»?",
  //   url: "https://halvacard.ru/order/credit-card/bez-poseshcheniya-banka/",
  // },
  // {
  //   title: "Моментальная кредитная карта",
  //   description: "Получить моментальную кредитную карту или карту «Халва»?",
  //   url: "https://halvacard.ru/order/credit-card/momentalnaya/",
  // },
  // {
  //   title: "Кредитная карта 180 дней без процентов",
  //   description: "Получить кредитную карту 180 дней без процентов или карту «Халва»?",
  //   url: "https://halvacard.ru/order/credit-card/s-besprocentnym-periodom-180-dnej/",
  // },
  // {
  //   title: "Кредитная карта с 18 лет",
  //   description: "Получить кредитную карту с 18 лет или карту «Халва»?",
  //   url: "https://halvacard.ru/order/credit-card/s-18-i-let/",
  // },
  // {
  //   title: "Кредитная карта с доставкой на дом",
  //   description: "Получить кредитную карту с доставкой на дом или карту «Халва»?",
  //   url: "https://halvacard.ru/order/credit-card/s-dostavkoi-na-dom/",
  // },

  // {
  //   title: "Кредитная карта с бесплатным обслуживанием",
  //   description: "Получить кредитную карту с бесплатным обслуживанием или карту «Халва»?",
  //   url: "https://halvacard.ru/order/credit-card/s-besplatnym-obsluzhivaniem/",
  // },
  // {
  //   title: "Кредитная карта на 50 тысяч рублей в Москве",
  //   description: "Получить кредитную карту на 50 тысяч рублей в москве или карту «Халва»?",
  //   url: "https://halvacard.ru/order/credit-card/do-50000-rublej/",
  // },
  // {
  //   title: "Кредитная карта для пенсионеров",
  //   description: "Получить кредитную карту для пенсионеров или карту «Халва»?",
  //   url: "https://halvacard.ru/order/credit-card/dlya-pensionerov/",
  // },
  // {
  //   title: "Виртуальная кредитная карта «МИР»",
  //   description: "Получить виртуальную кредитную карту «МИР» или карту «Халва»?",
  //   url: "https://halvacard.ru/order/credit-card/virtualnaja-mir/",
  // },
  // {
  //   title: "Кредитная карта по паспорту",
  //   description: "Получить кредитную карту по паспорту или карту «Халва»?",
  //   url: "https://halvacard.ru/order/credit-card/po-pasportu/",
  // },
]

export const ZAIMY_CARDS_LIST = [
  {
    title: "Займ онлайн",
    description: "Что лучше: взять займ онлайн или рассрочку*?",
    url: "https://halvacard.ru/order/zaimy/",
  },
  {
    title: "Моментальный займ на карту",
    description: "Займ на карту мгновенно на один раз или Халва навсегда?",
    url: "https://halvacard.ru/order/zaimy/momentalnyi-na-kartu/",
  },
  {
    title: "Займ без переплат",
    description: "Что выгоднее: займ без переплат или карта с рассрочкой*?",
    url: "https://halvacard.ru/order/zaimy/bez-procentov/",
  },
  {
    title: "Займ до зарплаты",
    description: "Займ до зарплаты или «Халва» с лимитом на рассрочку*?",
    url: "https://halvacard.ru/order/zaimy/do-zarplaty/",
  },
  {
    title: "Займ с плохой кредитной историей",
    description:
      "Что выгоднее: займ с плохой кредитной историей или Халва с беспроцентной рассрочкой*?",
    url: "https://halvacard.ru/order/zaimy/s-plohoi-ki/",
  },
  {
    title: "Займ от частного лица",
    description: "Займ от частного лица или проверенная карта с заемным лимитом?",
    url: "https://halvacard.ru/order/zaimy/ot-chastnogo-lica/",
  },
  {
    title: "Экспресс займ",
    description: "Одноразовый экспресс займ или карта с пополняемым лимитом?",
    url: "https://halvacard.ru/order/zaimy/express/",
  },
  {
    title: "Займ без отказа",
    description: "Ищем выгоду: займ без отказа или карта от проверенного банка",
    url: "https://halvacard.ru/order/zaimy/bez-otkaza/",
  },
  {
    title: "Займ на 30 дней",
    description: "Денежный займ на 30 дней или карта с лимитом навсегда?",
    url: "https://halvacard.ru/order/zaimy/na-30-dnej/",
  },
  {
    title: "Займ на 100.000 рублей",
    description: "Срочный займ на 100000 рублей или карта с лимитом до 500000 рублей?",
    url: "https://halvacard.ru/order/zaimy/na-100000-rublei/",
  },
]

export const DEBET_CARDS_LIST = [
  {
    title: "Дебетовая карта с доставкой курьером",
    description: "Дебетовая карта онлайн или Халва с доставкой курьером?",
    url: "https://halvacard.ru/order/debet-cards/s-dostavkoj-na-dom/",
  },
  {
    title: "Дебетовая карта для подростков",
    description: "Получить карту для подростков или Халву с предложениями для всех возрастов?",
    url: "https://halvacard.ru/order/debet-cards/dlya-podrostka/",
  },
  {
    title: "Дебетовая карта для нерезидентов",
    description: "Выбрать карту для нерезидентов или максимум возможностей с Халвой?",
    url: "https://halvacard.ru/order/debet-cards/dlya-nerezidentov/",
  },
]
